import { render, staticRenderFns } from "./debtor-form.vue?vue&type=template&id=29f374e6&"
import script from "./debtor-form.vue?vue&type=script&lang=js&"
export * from "./debtor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports